import FieldsCollection from "../../fields3/collection/base/fields-collection";

export default class CrmAccountFields {

    static getFieldsConfig() {
        // add system fields
        const systemFields = CrmAccountFields.getSystemFieldsConfig();
        const customFields = CrmAccountFields.getCustomFieldsConfig();

        return [...systemFields, ...customFields];
    }

    static getSystemFieldsConfig() {
        /*const companyUsers = gd.session.companyUsers.filterByCompany(gd.companyId).map(cu=>({
            value: cu.user.id,
            label: cu.user.name
        }));*/

        return [
            {fieldId: 'name',               label: 'Name',              type: gd.const.fields.type.STRING,              defaultWidth: 200,  isRequired: true},
            {fieldId: 'accountOwnerUserId', label: 'Account owner',     type: gd.const.fields.type.USER,                defaultWidth: 180,  }, //options: companyUsers
            {fieldId: 'phone',              label: 'Phone',             type: gd.const.fields.type.PHONE,               defaultWidth: 140,},
            {fieldId: 'email',              label: 'Email',             type: gd.const.fields.type.EMAIL,               defaultWidth: 160},
            {fieldId: 'website',            label: 'Website',           type: gd.const.fields.type.URL,                 defaultWidth: 160},
            {fieldId: 'notes',              label: 'Notes',             type: gd.const.fields.type.TEXT,                defaultWidth: 200},

            {fieldId: 'crmContactsTotal',   label: 'People',            type: gd.const.fields.type.CRM_CONTACTS_TOTAL,  isDerived: true},
        ]
    }

    static getCustomFieldsConfig() {
        const company = gd.session.companies.get(gd.companyId);
        const fields = company.settings.modules.crmAccount.customFields || [];
        _.map(fields, field=>{
            field.isCustom = true;
        })
        return fields;
    }


    static saveCustomFields(fieldsCollection: FieldsCollection) {

        const customFields = fieldsCollection.customFields();
        const config = _.map(customFields, field=>field.toJson());

        const company = gd.session.companies.get(gd.companyId);
        company.settings.modules.crmAccount.customFields = config;
        company.settings.save()
    }
}
